// Angular
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule, ModuleWithProviders } from '@angular/core';

// Modules
import { PaginationModule, TimepickerModule, BsDropdownModule, PopoverModule, TypeaheadModule } from 'ngx-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

// Components
import { PanelComponent } from './components/panel/panel.component';
import { POIView } from './components/poi/poiView/poi-view.directive';
import { ImageModal } from './components/imageModal/image-modal.component';
import { ImportFile } from './components/importFile/import-file.component';
import { ListView, SearchList, SortList } from './components/listView/index';
import { LeftNavMenu } from './components/leftNavMenu/left-nav-menu.component';
import { POIDetails } from './components/poi/poiDetails/poi-details.component';
import { CommonMapComponent } from './components/commonMap/common-map.component';
import { MapComponent } from './components/mapComponent/map-Component.component';
import { mappointer } from './components/mappointer/mappointer';
import { ErrorHandler } from './components/errorHandler/error-handler.component';
import { PickLocation } from './components/pickLocation/pick-location.component';
import { MyDatePicker } from './components/myDatePicker/my-date-picker.component';
import { MyTimePicker } from './components/mytimePicker/mytime-picker.component';
import { PageNotFound } from './components/pageNotFound/page-not-found.component';
import { unauthorizePage } from './components/unauthorizePage/unauthorize-page.component';
import { MessageDialog } from './components/messageDialog/message-dialog.component';
import { FileAttachment } from './components/fileAttachment/file-attachment.component';
import { FileDropDirective, FileSelectDirective } from './components/fileUpload/index';
import { LanguagePicker } from './components/languagePicker/language-picker.component';
import { DrawInteractionComponent } from './components/drawingComponent/draw.component';
import { NotificationComponent } from './components/notification/notification.component';
import { PageLink } from './components/PageLink/page-link.component';
import { ConnectionStatus } from './components/connectionStatus/connection-status.component';
import { ImportMessageBox } from './components/importFile/importMessageBox/import-message-box.component';
import { UploadPictureComponent } from './components/profilePicture/uploadProfilePicture/upload-profile-picture.component';
import { PreviewPictureComponent } from './components/profilePicture/previewProfilePicture/preview-profile-picture.component';
import { DiagnosticsComponent } from './components/diagnostics/diagnostics.component';
import { EasyFormComponent } from './components/easyForms/components/form/form.component';
import { StringInputComponent } from './components/easyForms/components/string-input/string-input.component';
import { NumberInputComponent } from './components/easyForms/components/number-input/number-input.component';
import { FormErrorComponent } from './components/easyForms/components/error/error.component';
import { FormGroupComponent } from './components/easyForms/components/form-group/form-group.component';
import { FormTooltipComponent } from './components/easyForms/components/tooltip/tooltip.component';
import { FormSelectComponent } from './components/easyForms/components/options-input/options-input.component';
import { SelectOptionPipe } from './components/easyForms/pipes/select-option.pipe';
import { FormSubmitComponent } from './components/easyForms/components/submit/submit-input.component';
import { HomeComponent } from './components/Home/home.component';
import { InfiniteListComponent } from './components/infiniteList/infinite-list.component';
import { BasicBarChart } from './components/charts/barCharts/basicBarChart/BasicBarChart.component';
import { MultipleBarChart } from './components/charts/barCharts/multipleBarChart/MultipleBarChart.component';
import { InfoGraphicNumber } from './components/charts/infoGraphicNumber/infoGraphicNumber.component';
import { BasicLineChart } from './components/charts/lineCharts/basicLineChart/basicLineChart.component';
import { MultipleLineChart } from './components/charts/lineCharts/multipleLineChart/multipleLineChart.component';
import { BasicScatterChart } from './components/charts/scatterCharts/basicScatterChart/basicScatterChart.component';
import { DonutChartComponent } from './components/charts/pie/donute-chart/donut-chart.component';
import { PieChartComponent } from './components/charts/pie/pie-chart/pie-chart.component';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { SelectControlComponent } from './components/selectControl/select-control.component';
import { MapPopupComponent } from './components/mapPopup/map-popup.component';
//import { AmazingTimePickerModule } from 'amazing-time-picker'; 
import { SensorTabComponent } from './components/sensorsTabForm/sensors-tab-form.component';
import { PolicyTabComponent } from './components/policiesTabForm/policies-tab-form.component';
import { NotificationTabComponent } from './components/notificationTabForm/notification-tab-form.component';
import { CanbusTabComponent } from "./components/canbusTabForm/canbus-tab-form.component"
import { CountdownComponent } from "./components/countdownWidget/countdown-widget.component";
import { ProgressBarComponent } from "./components/progressBar/progress-bar.component";
import { PartialLoader } from './components/partialLoader/partial-loader.component';
import { onlineUsersComponent } from './components/OnlineUsers/OnlineUsers.component';
import { onlineVehiclesComponent } from './components/OnlineVehicles/OnlineVehciles.component';
// Services
import { ChartsService } from './services/chartService/charts.service';
import { MapService } from './services/maps/map.service';
import { LoaderService } from './services/loader-service';
import { MapService2 } from './services/maps/map2.service';
import { CounterService } from './services/counter.service';
import { RealTimeService } from './services/realtime.service';
import { ResourceService } from './services/resource.service';
import { MapHelper } from './services/maps/map-helper.service';
import { ScriptLoader } from './services/script-loader.service';
import { AppConfigService } from './services/app-config.service';
import { ImageModalService } from './services/image-modal.service';
import { AuthenticationService } from './services/authentication.service';
import { MapSettingsService } from './services/maps/map-settings.service'; 
import { MapUtilitiesServices } from './services/maps/map-Utilities.services'; 
import { MasterComponentService } from './services/master-component.service';
import { TransporterService } from './services/transporters/transporter.service';
import { UserControlServiceService } from './services/user-control-access.service';
import { SignalRNotificationService } from './services/signalR-notification.service';
import { RoutingAuthenticationService } from './services/routing-authentication';
import { ImportFileService } from './services/import-file.service';
import { TransporterDetailsViewService } from './services/transporters/transporter-details-view.service';
import { DiagnosticsService } from './services/diagnostics.service';
import { DateService } from './services/date.service';
import { CookiesService } from './services/cookies.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SensorTabService } from './services/sensors-tab-form.service';
import { PoliciesTabService } from './services/policies-tab-form.service';
import { NotificationsTabService } from './services/notification-tab-form.service';

// Pipes
import { EnumPipe } from './pipes/enum.pipe';
import { Orderby } from '../shared/pipes/orderby.pipe';
import { LocalizePipe } from '../shared/pipes/Localize.pipe';
import { CapitalizeFirstPipe, LimitPipe } from './pipes/capitalize-first.pipe';
import { DurationFormatPipe } from './pipes/duration-format.pipe';
import { DateTimeFormatPipe } from './pipes/date-time-format.pipe';
import { StaffFilterPipe } from './pipes/staff-filter.pipe';

// Providers
import { AuthGuard } from './providers/auth-guard.component';
import { CanDeactivateGuard } from './providers/can-deactivate-guard.service';
import { ErrorProviderService } from './providers/error-provider.service';
import { ImageUploadInputComponent } from './components/easyForms/components/image-upload-input/image-upload-input.component';
import { DateInputComponent } from './components/easyForms/components/date-input/date-input.component';
import { TabItemComponent } from './components/tabs/tab-item.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { LocalizeDirective } from './components/localize/localize.directive';
import { IErrorHandlerToken } from './dataModels/';
import { FilteredListComponent } from './components/filteredList/filtered-list.component';
import { FilteredListFilterPartDirective, FilteredListScrollPartDirective } from './components/filteredList/filtered-list-parts';
import { NotifierComponent } from './components/notifier/notifier.component';
import { INotifierToken } from './dataModels/contracts/INotifier';
import { NotifierProviderService } from './providers/notifier-provider.service';
import { InformationProvider } from './providers/information.provider';
import { LookupService } from './services/lookup.service';
import { MapTocComponent } from './components/mapTools/mapToc/map-toc.component';
import { DatePicker } from './components/DatePicker/date-picker.component';
import { WindowUnloadService } from './services/window-unload.service';
import { PanicAlertComponent } from './components/PanicAlert/panic-alert/panic-alert.component';
import { PanicDetailsComponent } from './components/PanicAlert/panic-details/panic-details.component';
import { ResolvePanicComponent } from './components/PanicAlert/resolve-panic/resolve-panic.component';
import { PanicRoleService } from './services/PanicRole.service';
import { LineWithCustomBulletsChartComponent } from './components/charts/lineCharts/line-with-custom-bullets/line-with-custom-bullets.component';
import { SimpleColumnChartComponent } from './components/charts/barCharts/simple-column-chart/simple-column-chart.component';
import { PanicAlertListComponent } from './components/PanicAlert/panic-alert-list.component';
import { StackedClusteredColumnChartComponent } from './components/charts/barCharts/stacked-clustered-column-chart/stacked-clustered-column-chart.component';
import { NewMultipleLineChartComponent } from './components/charts/lineCharts/multiple-line-chart/multiple-line-chart.component';
import { MultipleLinesBarsChartComponent } from './components/charts/gaugeCharts/multiple-lines-bars/multiple-lines-bars.component';
import { TrendLinesChartComponent } from './components/charts/lineCharts/trend-line/trend-line.component';
import { Funnel3DChartComponent } from './components/charts/funnelCharts/funnel-3d-chart/funnel-3d-chart.component';
import { SolidGaugeChartComponent } from './components/charts/gaugeCharts/solid-gauge/solid-gauge.component';
import { RingChartComponent } from './components/charts/gaugeCharts/ringChart/ring-chart.component';
import { MapAddress } from './services/maps/map-address.service';
import { HttpService } from './services/http.service';
import { XHRBackend, RequestOptions } from '@angular/http';
import { httpServiceFunction } from './services/http-utilities.service';
import { customeCheckboxComponent } from './components/customeCheckbox/customeCheckbox.component';
import { HoursConverterPipe } from './pipes/hoursConverter.pipe';
import { DurationTimePipe } from './pipes/duration-time.pipe';
import { SearchComponentComponent } from './components/searchComponent/search-component.component';
import { dualSelectMenu } from './components/dualSelectMenu/dualSelectMenu.component';
import { DateStringFormatPipe } from './pipes/date-string-format.pipe';
import { AltairLayerService } from './services/altairLayer.service';
import { OnlineUsersService } from './services/onlineUsers.service';
import { OnlineVehiclesService } from './services/onlineVehicles.service';
import { SignalRCoreNotificationService } from './services/signalRCore-notification.service';
import { SharedDataService } from './services/shared-data.service';


//import { NotificationUsers } from '../resourceManagement/components/shared/notificationUsers/notification-users.component';




let sharedDeclarations = [
    Orderby,
    EnumPipe,
    LimitPipe,
    LocalizePipe,
    CapitalizeFirstPipe,
    DurationFormatPipe,
    DateTimeFormatPipe,
    HoursConverterPipe,
    DurationTimePipe,
    DateStringFormatPipe,
    POIView,
    SortList,
    ListView,
    PageLink,
    ImageModal,
    ImportFile,
    POIDetails,
    SearchList,
    LeftNavMenu,
    MyDatePicker,
    MyTimePicker,
    ErrorHandler,
    PageNotFound,
    unauthorizePage,
    PickLocation,
    HomeComponent,
    MessageDialog,
    TabsComponent,
    FileAttachment,
    PanelComponent,
    LanguagePicker,
    ConnectionStatus,
    ImportMessageBox,
    TabItemComponent,
    FileDropDirective,
    CommonMapComponent,
    MapComponent,
    mappointer,
    FileSelectDirective,
    DiagnosticsComponent,
    InfiniteListComponent,
    FilteredListComponent,
    NotificationComponent,
    UploadPictureComponent,
    PreviewPictureComponent,
    DrawInteractionComponent,
    NotifierComponent,
    FilteredListFilterPartDirective,
    FilteredListScrollPartDirective,
    BasicBarChart,
    MultipleBarChart,
    InfoGraphicNumber,
    BasicLineChart,
    MultipleLineChart,
    BasicScatterChart,
    DonutChartComponent,
    PieChartComponent,
    SimpleColumnChartComponent,
    LineWithCustomBulletsChartComponent,
    StackedClusteredColumnChartComponent,
    NewMultipleLineChartComponent,
    MultipleLinesBarsChartComponent,
    SolidGaugeChartComponent,
    RingChartComponent,
    TrendLinesChartComponent,
    Funnel3DChartComponent,
    LocalizeDirective,
    SelectControlComponent,
    PanicAlertComponent,
    PanicDetailsComponent,
    ResolvePanicComponent,
    PanicAlertListComponent,
    //AmazingTimePickerModule,


    EasyFormComponent,
    StringInputComponent,
    NumberInputComponent,
    FormErrorComponent,
    FormGroupComponent,
    FormTooltipComponent,
    FormSelectComponent,
    SelectOptionPipe,
    FormSubmitComponent,
    ImageUploadInputComponent,
    DateInputComponent,
    MapTocComponent,
    DatePicker,
    MapPopupComponent,
    customeCheckboxComponent,
    SearchComponentComponent,
    dualSelectMenu,
    //NotificationUsers,
    SensorTabComponent,
    PolicyTabComponent,
    NotificationTabComponent,
    CanbusTabComponent,
    StaffFilterPipe,
    CountdownComponent,
    ProgressBarComponent,
	PartialLoader,
	onlineVehiclesComponent,
	onlineUsersComponent,
];


let providers = [
    DurationFormatPipe,
    AuthGuard,
    CanDeactivateGuard,
    MapHelper,
    MapService,
    MapService2,
    LocalizePipe,
    ScriptLoader,
    LoaderService,
    LookupService,
    CounterService,
    ResourceService,
    RealTimeService,
    AppConfigService,
    AltairLayerService,
    ImageModalService,
    ImportFileService,
    DiagnosticsService,
    MapSettingsService,
    MapUtilitiesServices,
    TransporterService,
    AuthenticationService,
    MasterComponentService,
    UserControlServiceService,
    SignalRNotificationService,
    SignalRCoreNotificationService,
    RoutingAuthenticationService,
    TransporterDetailsViewService,
    WindowUnloadService,
    InformationProvider,
    ChartsService,
    ErrorProviderService,
    PanicRoleService,
    MapAddress,
    DateService,
    BsModalRef,
    BsModalService,
    DecimalPipe,
    CookiesService,
    SensorTabService,
    PoliciesTabService,
    NotificationsTabService,
    StaffFilterPipe,
	OnlineUsersService,
	OnlineVehiclesService,
    SharedDataService,
    {
        provide: 'IErrorHandler',
        useExisting: ErrorProviderService
    },

    {
        provide: IErrorHandlerToken,
        useExisting: ErrorProviderService
    },

    {
        provide: INotifierToken,
        useClass: NotifierProviderService
    },
    {
        provide: HttpService,
        useFactory: httpServiceFunction,
        deps: [XHRBackend, RequestOptions]
    }
    
]

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        InfiniteScrollModule,
        PaginationModule,
        TimepickerModule,
        NgxMyDatePickerModule.forRoot(),
        AngularMultiSelectModule,
        BsDropdownModule.forRoot(),
        PopoverModule.forRoot(),
        TypeaheadModule.forRoot(),
    ],
    declarations: sharedDeclarations,
    providers: [BsModalService, BsModalRef],
    exports: sharedDeclarations
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: providers
        }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/shared.module.ts